export function getIpType(ip: string): 'ip' | 'ipv6' {
  return ip.includes(':') ? 'ipv6' : 'ip';
}
